document.documentElement.classList.remove('no-js');

const menuButton = document.querySelector('[data-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');
const menuCloseButtons = document.querySelectorAll('[data-menu-close]');

if (menuButton && mobileMenu) {
  const setMenuOpen = (open) => {
    menuButton.setAttribute('aria-expanded', String(open));
    mobileMenu.hidden = !open;
    document.body.classList.toggle('menu-open', open);
  };

  menuButton.addEventListener('click', () => {
    const expanded = menuButton.getAttribute('aria-expanded') === 'true';
    setMenuOpen(!expanded);
  });

  menuCloseButtons.forEach((button) => {
    button.addEventListener('click', () => setMenuOpen(false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenuOpen(false);
  });
}

document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
  const slides = Array.from(slider.querySelectorAll('[data-hero-slide]'));
  const dots = Array.from(slider.querySelectorAll('[data-hero-dot]'));
  if (slides.length < 2) return;

  let active = 0;
  const show = (index) => {
    active = index;
    slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === active));
    dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === active));
  };

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => show(index));
  });

  window.setInterval(() => {
    show((active + 1) % slides.length);
  }, 5500);
});

document.querySelectorAll('[data-product-gallery-shell]').forEach((shell) => {
  const gallery = shell.querySelector('[data-product-gallery]');
  const slides = Array.from(gallery ? gallery.querySelectorAll('img') : []);
  const prevButton = shell.querySelector('[data-product-gallery-prev]');
  const nextButton = shell.querySelector('[data-product-gallery-next]');
  const dots = Array.from(shell.querySelectorAll('[data-product-gallery-dot]'));

  if (!gallery || slides.length < 2) return;

  let active = 0;

  const updateControls = () => {
    dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === active);
      dot.setAttribute('aria-current', index === active ? 'true' : 'false');
    });

    if (prevButton) prevButton.disabled = active === 0;
    if (nextButton) nextButton.disabled = active === slides.length - 1;
  };

  const scrollToSlide = (index) => {
    active = Math.max(0, Math.min(index, slides.length - 1));
    gallery.scrollTo({
      left: slides[active].offsetLeft,
      behavior: 'smooth'
    });
    updateControls();
  };

  prevButton?.addEventListener('click', () => scrollToSlide(active - 1));
  nextButton?.addEventListener('click', () => scrollToSlide(active + 1));

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => scrollToSlide(index));
  });

  gallery.addEventListener('scroll', () => {
    const nextActive = slides.reduce((closestIndex, slide, index) => {
      const currentDistance = Math.abs(slide.offsetLeft - gallery.scrollLeft);
      const closestDistance = Math.abs(slides[closestIndex].offsetLeft - gallery.scrollLeft);
      return currentDistance < closestDistance ? index : closestIndex;
    }, 0);

    if (nextActive !== active) {
      active = nextActive;
      updateControls();
    }
  }, { passive: true });

  updateControls();
});

document.querySelectorAll('[data-discount-popup]').forEach((popup) => {
  const form = popup.querySelector('[data-discount-form]');
  const input = form?.querySelector('input[name="phone"]');
  const closeButtons = popup.querySelectorAll('[data-discount-close]');
  const whatsappNumber = popup.dataset.whatsappNumber;
  const storageKey = 'manpasandDiscountPopupClosedUntil';
  const sevenDays = 7 * 24 * 60 * 60 * 1000;
  let autoCloseTimer;

  const closePopup = () => {
    popup.hidden = true;
    window.localStorage.setItem(storageKey, String(Date.now() + sevenDays));
    if (autoCloseTimer) window.clearTimeout(autoCloseTimer);
  };

  const closedUntil = Number(window.localStorage.getItem(storageKey) || 0);
  if (Date.now() > closedUntil) {
    window.setTimeout(() => {
      popup.hidden = false;
      input?.focus();
      autoCloseTimer = window.setTimeout(closePopup, 10000);
    }, 1400);
  }

  closeButtons.forEach((button) => button.addEventListener('click', closePopup));

  form?.addEventListener('submit', (event) => {
    event.preventDefault();
    const phone = input?.value.trim();
    if (!phone || phone.replace(/\D/g, '').length < 10) {
      input?.focus();
      return;
    }

    const message = `Hi, I want my 10% discount code. My number: ${phone}`;
    window.localStorage.setItem(storageKey, String(Date.now() + sevenDays));
    if (autoCloseTimer) window.clearTimeout(autoCloseTimer);
    window.open(`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`, '_blank', 'noopener');
    popup.hidden = true;
  });
});
